import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DatepickerOptions } from 'ng2-datepicker';
import * as moment from 'moment';

import Swal from 'sweetalert2'

/**
 * Service File
 */
import { VerifyDonationService } from "../../../services/donation/verifyDonation/verify-donation.service";


declare var $: any

@Component({
  selector: 'app-verify-donation',
  templateUrl: './verify-donation.component.html',
  styleUrls: ['./verify-donation.component.less']
})
export class VerifyDonationComponent implements OnInit {

  @Input('details') details: any;
  @Output() outToParent = new EventEmitter<string>()

  options: DatepickerOptions = {
    minYear: 1970,
    maxYear: 2030,
    displayFormat: 'MMM - DD - YYYY',
    barTitleFormat: 'MMM - DD - YYYY',
    dayNamesFormat: '',
    firstCalendarDay: 0, // 0 - Sunday, 1 - Monday
    // locale: frLocale,
    // minDate: new Date(Date.now()), // Minimal selectable date
    maxDate: new Date(Date.now()),  // Maximal selectable date
    barTitleIfEmpty: 'Click to select a date',
    placeholder: 'Click to select a date', // HTML input placeholder attribute (default: '')
    addClass: 'form-control', // Optional, value to pass on to [ngClass] on the input field
    addStyle: {}, // Optional, value to pass to [ngStyle] on the input field
    fieldId: 'my-date-picker', // ID to assign to the input field. Defaults to datepicker-<counter>
    useEmptyBarTitle: false, // Defaults to true. If set to false then barTitleIfEmpty will be disregarded and a date will always be shown 
  };

  public submitLoading: Boolean = false
  public OtherDate: Boolean = false

  constructor(private VerifyDonationService: VerifyDonationService) { }

  ngOnInit() {
  }

  async verifyDonation(value) {
    this.submitLoading = true

    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      onOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    })

    var range
    switch (parseInt(value.range)) {
      case 0:
        range = moment().subtract(0, "days").format("DD-MM-YYYY")
        console.log(range)
        break;
      case 1:
        range = moment().subtract(1, "days").format("DD-MM-YYYY")
        console.log(range)
        break;
      case 2:
        range = moment().subtract(2, "days").format("DD-MM-YYYY")
        break;
      case 3:
        range = moment().subtract(3, "days").format("DD-MM-YYYY")
        break;
      case 4:
        range = moment().subtract(4, "days").format("DD-MM-YYYY")
        break;
      case 5:
        range = moment(value.dateRange).format("DD-MM-YYYY")
        break;
    }
    let result = await this.VerifyDonationService.verify(this.details.receipt_id, range)
    if (result.status == "success") {
      $("#verifyDonation").modal("hide");
      Toast.fire({
        icon: 'success',
        title: 'Receipt Verified and Downloaded into Office Software DB'
      })
      this.outToParent.emit("success")
      this.submitLoading = false
    }
  }

  async getRange(type) {
    if (type == 5) {
      this.OtherDate = true
    } else {
      this.OtherDate = false
    }
  }

  getCustomDate(key) {
    switch (key) {
      case 0:
        return moment().subtract(0, "days").format("DD-MM-YYYY")
      case 1:
        return moment().subtract(1, "days").format("DD-MM-YYYY")
      case 2:
        return moment().subtract(2, "days").format("DD-MM-YYYY")
      case 3:
        return moment().subtract(3, "days").format("DD-MM-YYYY")
      case 4:
        return moment().subtract(4, "days").format("DD-MM-YYYY")

      default:
        break;
    }

  }


}

